import React from 'react';
import PropTypes from 'prop-types';
import TablePolynomyItem from './TablePolynomyItem';
import { __calculateTotalRestAdjustmentAmount } from '../../../../common/CommonFuctions';
import TablePolynomyItemNotAdjustment from './TablePolynomyItemNotAdjustment';

const TablePolynomyItems = ({ tableItems, parentPolinomyType, hasResources = false, handleDeletePolynomy, polynomyViewType, itemBodyClass = '', itemClass = 'w-20' }) => {
  // Verifica si tableItems es un array
  if (!Array.isArray(tableItems)) {
    console.error('tableItems debe ser un array');
    return null; // O cualquier otro manejo de error que desees
  }

  const totalRestAdjustmentAmount = __calculateTotalRestAdjustmentAmount(tableItems);

  const allTableItems = <>
                          {
                            tableItems.map(tableItem =>
                              (<TablePolynomyItem
                                  key={tableItem.id}
                                  parentPolinomyType={parentPolinomyType}
                                  tableItem={tableItem}
                                  polynomyViewType={polynomyViewType}
                                  addCardWidth={true}
                                  handleDeletePolynomy={handleDeletePolynomy}
                                  itemClass={itemClass}
                                  itemBodyClass={itemBodyClass}
                              />)
                            )
                          }
                          {
                            (!hasResources && totalRestAdjustmentAmount > 0) &&
                            <TablePolynomyItemNotAdjustment totalRestAdjustmentAmount={totalRestAdjustmentAmount} addCardWidth={true} />
                          }
                        </>

  return allTableItems;
};

TablePolynomyItems.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditFormOpen: PropTypes.func,
};

TablePolynomyItems.defaultProps = {
  tableItems: [{
    fechaBase: null,
    id: 0,
    mesesDesfase: null,
    partidaId:  0,
    periodicidadMeses: null,
    ponderador:  null,
    primerMesReajuste: null,
    subpartidaId: null,
    tipoPolinomioId: 0,
    valorBase: null,
  }]
};

export default TablePolynomyItems;
